import { HotjarFilterOptionAll, WatchedHotjarFilter } from '../store/list/types';
import { DEFAULT_RELEVANCE_SCORE_FILTER_VALUE } from './relevance';

export const DEFAULT_HOTJAR_FILTERS = {
  watched: HotjarFilterOptionAll as WatchedHotjarFilter,
  relevanceScore: DEFAULT_RELEVANCE_SCORE_FILTER_VALUE,
};
